<lib-qcloud-console *ngIf="!isLoading" [(deviceConfiguration)]="deviceConfiguration" [(projectType)]="ProjectTypeEnum"></lib-qcloud-console>
<div *ngIf="isLoading">loading</div>

